import { combineReducers, configureStore } from '@reduxjs/toolkit';
import AuthReducer, { isSessionEnd } from './reducers/AuthReducer';
import SearchReducer from './reducers/SearchReducer';
import DocumentReducer from './reducers/DocumentReducer';
import WidgetsReducer from './reducers/WidgetsReducer';
import ReportReducer from './reducers/ReportReducer';
import MainLayoutReducer from './reducers/MainLayoutReducer';
import DictionaryReducer from './reducers/DictionaryReducer';
import RolesReducer from './reducers/RolesReducer';
import UserAvatarReducer from './reducers/UserAvatarReducer';
import AppDataReducer from './reducers/AppDataReducer';
import ToursReducer from './reducers/ToursReducer';
import ChatAIHistoryReducer from './reducers/ChatAIHistoryReducer';
import { analyticsMiddleware } from './middleware/analyticsMiddleware';
import { authListenerMiddleware } from './middleware/authListener';

const appReducer = combineReducers({
    mainLayout: MainLayoutReducer,
    auth: AuthReducer,
    search: SearchReducer,
    document: DocumentReducer,
    widgets: WidgetsReducer,
    report: ReportReducer,
    dictionary: DictionaryReducer,
    roles: RolesReducer,
    userAvatar: UserAvatarReducer,
    appData: AppDataReducer,
    tours: ToursReducer,
    chatAIHistory: ChatAIHistoryReducer,
});

/** По окончании сессии остаются только слайсы вкладки, остальные возвращаются к начальному состоянию. */
const rootReducer: typeof appReducer = (state, action) => {
    const next = appReducer(state, action);
    if (!state?.auth || !isSessionEnd(state.auth, next.auth)) return next;
    return appReducer({ auth: next.auth, mainLayout: next.mainLayout, appData: next.appData }, action);
};

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware()
                .prepend(authListenerMiddleware.middleware)
                .concat(analyticsMiddleware),
        // С установленным расширением состояние стора (профиль, данные) видно и на проде — только в dev-сборке.
        devTools: import.meta.env.DEV,
    });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
